<h2 mat-dialog-title>
    Item Transactions
</h2>

<div mat-dialog-content fxLayout="column">
    <busy-indicator *ngIf="!isLoaded"></busy-indicator>

    <form [formGroup]="formGroup">
        <table *ngIf="isLoaded" mat-table [dataSource]="tableData" fxFill>
            <ng-container matColumnDef="TransactionDate">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="transactionDateFilter" label="Transaction Date">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.TransactionDate | date : 'M/d/yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="PostDate">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="postDateFilter" label="Post Date">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.PostDate | date : 'M/d/yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="TranDescription">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="tranDescriptionFilter" label="Transaction Description">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.TranDescription}} </td>
            </ng-container>

            <ng-container matColumnDef="Type">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="typeFilter" label="Type">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.Type}} </td>
            </ng-container>

            <ng-container matColumnDef="Number">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="numberFilter" label="Number">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.Number}} </td>
            </ng-container>

            <ng-container matColumnDef="ReqNumber">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="reqNumberFilter" label="ReqNumber">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.ReqNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="ShipNumber">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="shipNumberFilter" label="ShipNumber">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.ShipNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="Entry">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="entryFilter" label="Entry">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.Entry}} </td>
            </ng-container>

            <ng-container matColumnDef="PONumber">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="poNumberFilter" label="PO Number">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.PONumber}} </td>
            </ng-container>

            <ng-container matColumnDef="Description">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="descriptionFilter" label="Description">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.Description}} </td>
            </ng-container>

            <ng-container matColumnDef="ProjectAccount">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="projectAccountFilter" label="Project Account">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.ProjectAccount?.Name}} </td>
            </ng-container>

            <ng-container matColumnDef="ReqUserID">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="reqUserIDFilter" label="Req User ID">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.ReqUserID}} </td>
            </ng-container>

            <ng-container matColumnDef="Quantity">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="quantityFilter" label="Quantity">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.Quantity}} </td>
            </ng-container>

            <ng-container matColumnDef="Cost">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="costFilter" label="Cost">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.Cost | currency}} </td>
            </ng-container>

            <ng-container matColumnDef="Total">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="totalFilter" label="Total">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">{{row.Quantity * row.Cost | currency}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
            <tr mat-row *matRowDef="let myRowData; columns: columnNames"></tr>
        </table>
    </form>
</div>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end start">
    <command-bar [commands]="commands"></command-bar>
</div>